import React from 'react';
import ReactDOM from 'react-dom';
import clone from 'clone';
import { findIndex } from 'underscore';
import SidebarAction from '../../action/sidebarAction';
import SidebarStore from '../../store/sidebarStore';

class SidebarBlock extends React.Component {
  constructor(props) {
    super(props);
  }
  componentWillMount() {
    const allLayout = clone(this.props.allLayout);
    const uid = clone(this.props.uid);
    const indexOfSearch = findIndex(allLayout, { uid: uid.toString() });
    if (indexOfSearch !== -1) {
      const indexOfSidebar = findIndex(allLayout[indexOfSearch].searchAttr, { viewType: 'sidebar' });
      if (indexOfSidebar !== -1) {
        const name = allLayout[indexOfSearch].searchAttr[indexOfSidebar].sidebarName;
        SidebarAction.getSidebarWidget({ name });
      }
    }
  }
  componentDidMount() {
    SidebarStore.listen(this.renderSidebar.bind(this));
  }
  renderSidebar(data) {
    const target = ReactDOM.findDOMNode(this);
    jQuery(target).html(data);
    // alike
   window.loadAlike();
  }
  render() {
    const { settingsData } = this.props;
    const ThemeComponent = window.ReactiveTheme[settingsData.theme];
    return <ThemeComponent.widget />;
  }
}

export default SidebarBlock;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/preview/search/default/sidebarpreview.js
 **/